import { render, staticRenderFns } from "./CompanyPermissionRecordsSetting.vue?vue&type=template&id=010acd98"
import script from "./CompanyPermissionRecordsSetting.vue?vue&type=script&lang=js"
export * from "./CompanyPermissionRecordsSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('010acd98')) {
      api.createRecord('010acd98', component.options)
    } else {
      api.reload('010acd98', component.options)
    }
    module.hot.accept("./CompanyPermissionRecordsSetting.vue?vue&type=template&id=010acd98", function () {
      api.rerender('010acd98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/CompanyPermissionRecordsSetting.vue"
export default component.exports